import { StateReset } from 'ngxs-reset-plugin';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { Injectable } from '@angular/core';

import { UnitType } from '@mitsubishi/shared/data-access';

import { hasActionsExecuting } from '@ngxs-labs/actions-executing';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Store } from '@ngxs/store';

import { NewsActions } from '../actions/news.actions';
import { NewsSelectors } from '../selectors/news.selectors';
import { NewsState } from '../states/news.state';

@Injectable({
  providedIn: 'root',
})
export class NewsFacade {
  news$ = this.store.select(NewsSelectors.news);
  activeNews$ = this.store.select(NewsSelectors.activeNews);
  tagsNews$ = this.store.select(NewsSelectors.tagsNews);
  selectedTab$ = this.store.select(NewsSelectors.selectedTab);
  tagsFilterNews$ = this.store.select(NewsSelectors.selectedTags);

  isLoading$ = this.store
    .select(hasActionsExecuting([NewsActions.Load]))
    .pipe(debounceTime(150), distinctUntilChanged());

  constructor(private store: Store) {}

  @Dispatch()
  loadNews() {
    return new NewsActions.Load();
  }

  @Dispatch()
  setNewsType(type: number | null) {
    return new NewsActions.SetNewsType(type);
  }

  @Dispatch()
  setSearchText(searchText: string | null) {
    return new NewsActions.SetSearchText(searchText);
  }

  @Dispatch()
  loadTagsNews() {
    return new NewsActions.LoadTags();
  }

  @Dispatch()
  resetState() {
    return new StateReset(NewsState);
  }

  @Dispatch()
  setUnitFilters(unitId: string, unitType: UnitType) {
    return new NewsActions.SetUnitFilter(unitId, unitType);
  }

  @Dispatch()
  setSearchTags(tags: string[]) {
    return new NewsActions.SetSearchTags(tags);
  }
}
